/** Guest-realm no-op for the host-rendered Projects page (calendar/entry.js precedent). */
export const projectsEntrySource = `
(function () {
  var sdk = window.apibooSDK;
  sdk.onActivate(function () {});
})();
`;
